<div *ngFor="let section of sections">
  <div id="{{ section.heading }}" [innerHTML]="section.body | mdToHtml"></div>
  <!-- <div [innerHTML]="section.body | mdToHtml"></div> -->
  <div [innerHTML]="section.subBody || '' | mdToHtml"></div>
  <app-functional-capabilities-ribbon-tile-section
    *ngIf="section.ribbonTileSections?.length"
    [isRibbonTile]="true"
    [ribbonTileSections]="section.ribbonTileSections || []"
  ></app-functional-capabilities-ribbon-tile-section>
</div>
